import { applyMiddleware, compose, legacy_createStore as createStore } from "redux"
import reducers from "../reducers/index.ts"
import { routerMiddleware } from "react-router-redux"
import { createBrowserHistory as createHistory } from "history"
import createSagaMiddleware from "redux-saga"
import rootSaga from "../sagas/index"
import { getItems, setItems } from "util/localStorage"
import { stateSet } from "constants/StateDefault"

import { SIGNIN_USER_SUCCESS } from "constants/ActionTypes"

const history = createHistory()
const routeMiddleware = routerMiddleware(history)
const sagaMiddleware = createSagaMiddleware()

const middlewares = [sagaMiddleware, routeMiddleware]
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

function saveToLocalStorage(state) {

  try {

    const isAuthenticated = state.auth.authUser
    if (isAuthenticated) {
      const { ratePlan, reservations, city, country, channelList, listBoxs, calendarModule, ...res } = state
      const newRatePlan = { ...ratePlan, dataSource: [] }
      const newReservation = { ...reservations, dataSource: [] }
      const newChannelList = { ...channelList, dataSource: [] }
      const serializedState = JSON.stringify({
        ...res,
        ratePlan: { ...newRatePlan },
        reservations: { ...newReservation },
        channelList: { ...newChannelList }
      })
      setItems({
        [stateSet]: serializedState
      })
    }
  } catch (error) {
  }
}

function loadFromLocalStorage() {
  try {
    const state = getItems([stateSet])
    const serializedState = state[stateSet]
    if (serializedState === null || serializedState === undefined) return undefined
    else return JSON.parse(serializedState)
  } catch (error) {
    return undefined
  }
}

const rootReducer = (state, action) => {
  // If the user successfully signs in, reset the state before applying the login success changes
  if (action.type === SIGNIN_USER_SUCCESS) {
    // by calling the combined reducer with 'undefined' state.
    const appInitialState = reducers(undefined, { type: '@@INIT_RESET' })

    return {
      ...appInitialState,
      auth: {
        ...appInitialState.auth,
        loader: false,
        authUser: { ...action.payload } // The new user data!
      }
    }
  }
  //pass the current state and action to the combined reducer as usual.
  return reducers(state, action)
}

const persistedState = loadFromLocalStorage()

export default function configureStore(initialState = persistedState) {

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  )

  store.subscribe(() => saveToLocalStorage(store.getState()))

  sagaMiddleware.run(rootSaga)

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index.ts', () => {
      const nextRootReducer = require('../reducers/index.ts')
      const nextEnhancedReducer = (state, action) => {
        if (action.type === SIGNIN_USER_SUCCESS) {
          const appInitialState = nextRootReducer(undefined, { type: '@@INIT_RESET' })
          return {
            ...appInitialState,
            auth: {
              ...appInitialState.auth,
              loader: false,
              authUser: { ...action.payload },
            },
          }
        }
        return nextRootReducer(state, action)
      }
      store.replaceReducer(nextEnhancedReducer)
    })
  }
  return store
}
export { history }
